<template>
  <div>
    Infoermations
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>
